/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { Row, Col } from 'react-bootstrap';

const whoWeAreText = `We are a small team of developers, designers, and brokers offering software engineering, finance, and real estate services. Our engineering services include custom software, mobile, and web development to help businesses streamline operations and improve productivity. Our finance services cover business, personal, salary, and logbook loans to support informed financial decisions. Our real estate services include property search, acquisition, management, leasing, and investment advisory to help clients achieve their property goals.`;

const whyWeExistText = `We strive to deliver high-quality and cost-effective solutions that meet our clients’ unique needs and exceed their expectations.`;
const chooseUsCss = {
  self: css({
    minHeight: 0,
    margin: '0 0 2.5rem',
    padding: '3.5rem 4rem 4rem',
    backgroundColor: '#095352',
    '@media only screen and (max-width: 600px)': {
      padding: '1.25rem 1rem 2rem',
      display: 'block',
    },
  }),
  whoWeAre: css({
    padding: '1.5rem 2.25rem 2rem 2rem',
    '@media only screen and (max-width: 600px)': {
      padding: '1rem 0.5rem 1.5rem',
    },
  }),
  whyWeExist: css({
    padding: '1.5rem 2.25rem 2rem 2rem',
    opacity: 0.95,
    borderRadius: '8px',
    backgroundColor: '#398d8c',
    '@media only screen and (max-width: 600px)': {
      padding: '1rem 0.75rem 1.5rem',
      marginTop: '0.5rem',
    },
  }),
  chooseUsSectionTitle: css({
    margin: '0 0 1rem 0',
    paddingBottom: '0.5rem',
    borderBottom: '2px solid rgba(255, 255, 255, 0.22)',
    fontFamily:
      "'Plus Jakarta Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    fontSize: 'clamp(1.45rem, 3.2vw, 1.9rem)',
    fontWeight: 700,
    lineHeight: 1.28,
    letterSpacing: '-0.02em',
    color: '#ffffff',
    textAlign: 'left',
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'antialiased',
  }),
  chooseUsSectionDescription: css({
    color: '#ffffff',
    fontSize: '1.05rem',
    lineHeight: 1.65,
  }),
  paragraph: css({
    margin: '0 0 1rem',
    '&:last-of-type': {
      marginBottom: 0,
    },
  }),
  inlineLink: css({
    color: '#bff8f4',
    fontWeight: 700,
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    '&:hover': {
      color: '#ffffff',
    },
  }),
};



const ChooseUsSectionDescription = ({ children }) => {
  return <div css={chooseUsCss.chooseUsSectionDescription}>{children}</div>;
};

function About() {
  return (
    <>
      <h2 id="about" className="main-title text-center about-h2 about-scroll">
        ABOUT US
      </h2>
      <p className="about-section-lead text-center">
        Renstia Loans, Renstia Real Estate, and the tech team behind the software and real estate services.
      </p>
      <Row css={chooseUsCss.self}>
        <Col css={chooseUsCss.whoWeAre}>
          <h2 css={chooseUsCss.chooseUsSectionTitle}>Who we are</h2>
          <ChooseUsSectionDescription>
            <p css={chooseUsCss.paragraph}>{whoWeAreText}</p>
          </ChooseUsSectionDescription>
        </Col>
        <Col css={chooseUsCss.whyWeExist}>
          <h2 css={chooseUsCss.chooseUsSectionTitle}>Why we&apos;re here</h2>
          <ChooseUsSectionDescription>
            <p css={chooseUsCss.paragraph}>{whyWeExistText}</p>
          </ChooseUsSectionDescription>
        </Col>
      </Row>
    </>
  );
}

export default About;
